Librarian.PageBuilder.getGreetingString = function() {
    var userName = (Librarian.userInfo.FirstName || '').trim();
    if (userName.length == 0) {
        var email = Librarian.userInfo.Email,
            atIndex = email.indexOf('@');

        userName = email.substring(0, atIndex);
    }

    return Librarian.Lang.getString("homepage_greeting") + " " + userName;
};

Librarian.PageBuilder.getTwoLineGreetingString = function () {
    var userName = (Librarian.userInfo.FirstName || '').trim();
    if (userName.length == 0) {
        var email = Librarian.userInfo.Email,
            atIndex = email.indexOf('@');

        userName = email.substring(0, atIndex);
    }

    return  Librarian.Lang.getString("homepage_greeting") + " " + " <br/>" + userName;
};

Librarian.PageBuilder.templates = {

    /* Grid Templates */

    Grid: {
        width: 510,
        numModules: 9,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 100,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 3,
                    height: 490,
                    modules: [
                        {
                            modules: [
                                moduleArray[0],
                                moduleArray[1],
                                moduleArray[2]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[3],
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[6],
                                moduleArray[7],
                                moduleArray[8]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    Grid2: {
        width: 850,
        numModules: 12,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 100,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 5,
                    height: 490,
                    modules: [
                        {
                            modules: [
                                moduleArray[0],
                                moduleArray[1]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[2],
                                moduleArray[3]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[6],
                                moduleArray[7],
                                moduleArray[8]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[9],
                                moduleArray[10],
                                moduleArray[11]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    /* Metro Tile Templates */

    MetroTileHomepage: {
        width: 1020,
        numModules: 10,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 195,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[9]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            modules: [
                                moduleArray[0],
                                moduleArray[2]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[1],
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4],
                                {
                                    modules: [
                                        {
                                            id: "dummy",
                                            type: "Module"
                                        },
                                        moduleArray[5]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[6],
                                        moduleArray[7]
                                    ]
                                },
                                moduleArray[8]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage2: {
        width: 1020,
        numModules: 13,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 156,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[0]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            modules: [
                                moduleArray[1],
                                moduleArray[2],
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4],
                                {
                                    modules: [
                                        moduleArray[5],
                                        moduleArray[6]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[7],
                                {
                                    modules: [
                                        moduleArray[8],
                                        moduleArray[9]
                                    ]
                                }
                            ]
                        },
                        {
                            modules: [
                                moduleArray[10],
                                moduleArray[11],
                                moduleArray[12]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage3: {
        width: 1020,
        numModules: 10,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 156,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[0]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1],
                                {
                                    modules: [
                                        moduleArray[2],
                                        moduleArray[3]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4],
                                {
                                    modules: [
                                        moduleArray[5],
                                        moduleArray[6]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[7],
                                {
                                    modules: [
                                        moduleArray[8],
                                        moduleArray[9]
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage4: {
        width: 1020,
        numModules: 9,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 156,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[0]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            colSpan: 3,
                            modules: [
                                moduleArray[1],
                                {
                                    modules: [
                                        moduleArray[2],
                                        moduleArray[3],
                                        moduleArray[4]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[5],
                                {
                                    modules: [
                                        moduleArray[6],
                                        moduleArray[7],
                                    ]
                                }
                            ]
                        },
                        {
                            modules: [
                                moduleArray[8],
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage5: {
        width: 1020,
        numModules: 11,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    colCount: 6,
                    height: 156,
                    modules: [
                        {
                            colSpan: 3,
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            colSpan: 4,
                            modules: [
                                moduleArray[3],
                                {
                                    colSpan: 1,
                                    modules: [
                                        moduleArray[4],
                                        moduleArray[5],
                                        moduleArray[6],
                                        moduleArray[7]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    colSpan: 1,
                                    modules: [
                                        moduleArray[8],
                                        moduleArray[9]
                                    ]
                                },
                                moduleArray[10]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage6: {
        width: 510,
        numModules: 3,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 156,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 3,
                    height: 312,
                    modules: [
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[0],
                                moduleArray[1]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[2]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage7: {
        width: 1020,
        numModules: 13,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        },
                        {
                            modules: [
                                moduleArray[12]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            modules: [
                                moduleArray[0],
                                moduleArray[1],
                                moduleArray[2]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[3],
                                        moduleArray[4]
                                    ]
                                },
                                moduleArray[5]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[6],
                                        moduleArray[7]
                                    ]
                                },
                                moduleArray[8]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[9],
                                moduleArray[10],
                                moduleArray[11]
                            ]
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage8: {
        width: 850,
        numModules: 8,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[5]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[6],
                                moduleArray[7]
                            ]
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage9: {
        width: 1020,
        numModules: 9,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 195,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[8]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[0],
                                        moduleArray[1]
                                    ]
                                },
                                {
                                    colSpan: 2,
                                    modules: [
                                        moduleArray[2]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3],
                                {
                                    modules: [
                                        {
                                            id: "dummy",
                                            type: "Module"
                                        },
                                        moduleArray[4]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[5],
                                        moduleArray[6]
                                    ]
                                },
                                moduleArray[7]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage10: {
        width: 1020,
        numModules: 11,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 195,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[9]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            modules: [
                                moduleArray[0],
                                moduleArray[2]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[1],
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4],
                                {
                                    modules: [
                                        moduleArray[10],
                                        moduleArray[5]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[6],
                                        moduleArray[7]
                                    ]
                                },
                                moduleArray[8]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage11: {
        width: 850,
        numModules: 9,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        moduleArray[3],
                        moduleArray[8]
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[5]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[6],
                                moduleArray[7]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage12: {
        width: 850,
        numModules: 18,
        getTemplate: function(moduleArray, greetingString) {
            return [
                {
                    rowCount: 4,
                    colCount: 5,
                    height: 660,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0],
                                moduleArray[14]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1],
                                moduleArray[15],
                            ]
                        },
                        {
                            modules: [
                                moduleArray[2],
                                moduleArray[3],
                                moduleArray[8],
                                moduleArray[13],
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[4],
                                moduleArray[9]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[5],
                                moduleArray[10]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[6],
                                moduleArray[11]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[7],
                                moduleArray[12]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[16],
                                moduleArray[17]
                            ]
                        },
                    ]
                }
            ];
        }
    },

    MetroTileHomepage13: {
        width: 850,
        numModules: 7,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 161,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        {
                            colSpan: 3,
                            modules: [
                                moduleArray[2]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[5],
                                moduleArray[6]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage14: {
        width: 900,
        numModules: 14,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[2],
                                moduleArray[3]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[4],
                                moduleArray[8]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[5],
                                moduleArray[9]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[6],
                                moduleArray[10]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[7],
                                moduleArray[11]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[12],
                                moduleArray[13]
                            ]
                        },
                    ]
                }
            ];
        }
    },

    MetroTileHomepage15: {
        width: 850,
        numModules: 16,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[2],
                                moduleArray[3]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 5,
                    height: 490,
                    modules: [
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[4],
                                moduleArray[8],
                                moduleArray[12]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[5],
                                moduleArray[9],
                                moduleArray[13]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[6],
                                moduleArray[10],
                                moduleArray[14]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    colSpan: 2,
                                    modules: [
                                        moduleArray[7],
                                        moduleArray[11]
                                    ]
                                },
                                moduleArray[15]
                            ],
                        },
                    ]
                }
            ];
        }
    },

    MetroTileHomepage16: {
        width: 850,
        numModules: 11,
        getTemplate: function(moduleArray, greetingString) {
            return [
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[1]
                            ]
                        },
                        {
                            colSpan: 3,
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[2],
                                        moduleArray[3]
                                    ]
                                },
                                moduleArray[4]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[5],
                                        moduleArray[6]
                                    ]
                                },
                                moduleArray[7]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[8],
                                moduleArray[9],
                                moduleArray[10]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage17: {
        width: 1020,
        numModules: 13,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 161,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[5]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[6],
                                moduleArray[7]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 161,
                    modules: [
                        moduleArray[8],
                        moduleArray[9],
                        moduleArray[10],
                        moduleArray[11],
                        moduleArray[12],
                    ]
                },
            ];
        }
    },

    MetroTileHomepage18: {
        width: 1020,
        numModules: 12,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 156,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 6,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[2]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3],
                                {
                                    modules: [
                                        moduleArray[4],
                                        moduleArray[5]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[6],
                                {
                                    modules: [
                                        moduleArray[7],
                                        moduleArray[8]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[9],
                                {
                                    modules: [
                                        moduleArray[10],
                                        moduleArray[11]
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    height: 30,
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html":
                                    "For questions about library functions or technical issues, call 855-515-4083 or email marketingcentral@ubs.com"
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage19: {
        width: 1020,
        numModules: 13,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 6,
                    height: 161,
                    modules: [
                        moduleArray[0],
                        {
                            colSpan: 3,
                            modules: [
                                moduleArray[1]
                            ]
                        },
                        moduleArray[9],
                        moduleArray[10]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[2],
                                {
                                    modules: [
                                        moduleArray[3],
                                        moduleArray[4]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[5],
                                        moduleArray[6]
                                    ]
                                },
                                moduleArray[7]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[8],
                                {
                                    modules: [
                                        moduleArray[11],
                                        moduleArray[12]
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage20: {
        width: 1020,
        numModules: 14,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 195,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[9]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            modules: [
                                moduleArray[0],
                                moduleArray[2]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[1],
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[4],
                                        moduleArray[11]
                                    ]
                                },
                                {
                                    modules: [
                                        moduleArray[12],
                                        moduleArray[13]
                                    ]
                                },
                                {
                                    modules: [
                                        moduleArray[10],
                                        moduleArray[5]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[6],
                                        moduleArray[7]
                                    ]
                                },
                                moduleArray[8]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage21: {
        width: 850,
        numModules: 6,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        {
                            colSpan: 4,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        moduleArray[1],
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[2]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage22: {
        width: 850,
        numModules: 6,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 161,
                    modules: [
                        {
                            colSpan: 3,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[2]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage24: {
        width: 900,
        numModules: 20,
        getTemplate: function(moduleArray, greetingString) {
            return [
                {
                    rowCount: 4,
                    colCount: 5,
                    height: 660,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0],
                                moduleArray[14],
                                {
                                    modules: [
                                        moduleArray[18],
                                        moduleArray[19],
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1],
                                moduleArray[15],
                            ]
                        },
                        {
                            modules: [
                                moduleArray[2],
                                moduleArray[3],
                                moduleArray[8],
                                moduleArray[13],
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[4],
                                moduleArray[9]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[5],
                                moduleArray[10]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[6],
                                moduleArray[11]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[7],
                                moduleArray[12]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[16],
                                moduleArray[17]
                            ]
                        },
                    ]
                }
            ];
        }
    },

    MetroTileHomepage25: {
        width: 680,
        numModules: 9,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 4,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[1],
                                moduleArray[2]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[3],
                                moduleArray[4]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 4,
                    height: 156,
                    modules: [
                        moduleArray[5],
                        moduleArray[6],
                        moduleArray[7],
                        moduleArray[8]
                    ]
                },
            ];
        }
    },

    MetroTileHomepage26: {
        width: 850,
        numModules: 8,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 4,
                            rowSpan: 2,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[1],
                                moduleArray[2]
                            ]
                        },
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 161,
                    modules: [
                        moduleArray[3],
                        moduleArray[4],
                        moduleArray[5],
                        moduleArray[6],
                        moduleArray[7]
                    ]
                }
            ];
        }
    },

    MetroTileHomepage27: {
        width: 850,
        numModules: 11,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        {
                            colSpan: 4,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        moduleArray[1],
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[2]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 161,
                    modules: [
                        moduleArray[6],
                        moduleArray[7],
                        moduleArray[8],
                        moduleArray[9],
                        moduleArray[10]
                    ]
                }
            ];
        }
    },

    MetroTileHomepage28: {
        width: 1020,
        numModules: 12,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 76,
                    colCount: 6,
                    modules: [
                        {
                            colSpan: 2,
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        {
                            colSpan: 4,
                            type: "Search",
                            id: "search",
                            options: {
                                searchPlaceholder: "Search All Content",
                                searchButtonText: "Content Search"
                            }
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 6,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[2],
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 6,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[6]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[7]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[8],
                                moduleArray[9]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[10],
                                moduleArray[11]
                            ]
                        }
                    ]
                },
                {
                    height: 30,
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html":
                                    "For questions about library functions or technical issues, call 855-515-4083 or email marketingcentral@ubs.com"
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage29: {
        width: 850,
        numModules: 7,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        {
                            colSpan: 3,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        moduleArray[1],
                        moduleArray[2]
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 312,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[5],
                                moduleArray[6]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage30: {
        width: 900,
        numModules: 8,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 4,
                    colCount: 5,
                    height: 660,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0],
                                moduleArray[4]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[1],
                                        moduleArray[2],
                                    ]
                                },
                                moduleArray[5],
                            ]
                        },
                        {
                            modules: [
                                moduleArray[3],
                                moduleArray[6],
                                moduleArray[7],
                            ]
                        }
                    ]
                },
            ];
        }
    },

    MetroTileHomepage31: {
        width: 850,
        numModules: 6,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getTwoLineGreetingString();


            return [
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        {
                            colSpan: 3,
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            modules: [
                                moduleArray[2],
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[5]
                            ]
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage32: {
        width: 680,
        numModules: 10,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString() + '<p>Welcome to Accent, a global software platform just for ESS that serves as a central library for PowerPoint slides, case studies, and proposal templates.</p>';

            return [
                {
                    rowCount: 1,
                    colCount: 4,
                    height: 156,
                    modules: [
                        {
                            colSpan: 3,
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 4,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        moduleArray[3]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 4,
                    height: 490,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[4],
                                        moduleArray[5],
                                    ]
                                },
                                moduleArray[6]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[7],
                                {
                                    modules: [
                                        moduleArray[8],
                                        moduleArray[9],
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ];
        }        
    },

    MetroTileHomepage33: {
        width: 1020,
        numModules: 9,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 6,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        moduleArray[3],
                        moduleArray[4],
                        moduleArray[5]

                        
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 6,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[6]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[7]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[8]
                            ]
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage34: {
        width: 850,
        numModules: 10,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            modules: [
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[6],
                                moduleArray[7]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[8]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[9]
                            ]
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage35: {
        width: 680,
        numModules: 11,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString() + '<p>Welcome to Accent, a global software platform just for ESS that serves as a central library for PowerPoint slides, case studies, and proposal templates.</p>';

            return [
                {
                    rowCount: 1,
                    colCount: 4,
                    height: 156,
                    modules: [
                        {
                            colSpan: 4,
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 4,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[0],
                                        moduleArray[1]
                                    ]
                                },
                                {
                                    modules: [
                                        moduleArray[2],
                                        moduleArray[3]
                                    ]
                                },
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 4,
                    height: 490,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[5],
                                        moduleArray[6]
                                    ]
                                },
                                moduleArray[7]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[8],
                                        moduleArray[9]
                                    ]
                                },
                                moduleArray[10]
                            ]
                        }
                    ]
                }
            ];
        }        
    },

    MetroTileHomepage36: {
        width: 850,
        numModules: 11,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        moduleArray[3],
                        moduleArray[4]
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {                             
                                modules: [
                                    moduleArray[5],
                                    moduleArray[6]
                                ]
                            },
                                moduleArray[7]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[8]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[9],
                                moduleArray[10]
                            ]
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    }, 

    MetroTileHomepage38: {
        width: 850,
        numModules: 8,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            modules: [
                                moduleArray[0],
                                moduleArray[1]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[2]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3]
                            ]
                        }                       
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            modules: [
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[6]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[7]
                            ]
                        }                       
                    ]
                }
            ];
        }
    },

    MetroTileHomepage39: {
        width: 850,
        numModules: 12,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        moduleArray[3],
                        moduleArray[4]
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[5],
                                        moduleArray[6]
                                    ]
                                },
                                {
                                    modules: [
                                        moduleArray[7],
                                        moduleArray[8]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[9]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[10],
                                moduleArray[11]
                            ]
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage40: {
        width: 850,
        numModules: 12,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        moduleArray[3],
                        moduleArray[4]
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[5]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[6]
                            ]
                        },
                        moduleArray[7]
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[8]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[9]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[10],
                                moduleArray[11]
                            ]
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage41: {
        width: 850,
        numModules: 11,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        {
                            colSpan: 3,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[0],
                                        moduleArray[1],
                                        moduleArray[2]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[3]
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[4],
                                        moduleArray[5]
                                    ]
                                },
                                {
                                    modules: [
                                        moduleArray[6],
                                        moduleArray[7]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[8]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[9],
                                moduleArray[10]
                            ]
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage42: {
        width: 1020,
        numModules: 4,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 4,
                    height: 490,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        moduleArray[3]
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html": Librarian.Lang.getString("modules_questions_message")
                            }
                        }
                    ]
                }
            ];
        }
    },

    MetroTileHomepage43: {
        width: 850,
        numModules: 14,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[0],
                        moduleArray[1],
                        moduleArray[2],
                        moduleArray[3],
                        moduleArray[4]
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 322,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[5]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[6]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[7],
                                moduleArray[8]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[9],
                        moduleArray[10],
                        moduleArray[11],
                        moduleArray[12],
                        moduleArray[13]
                    ]
                }
            ];
        }
    },

    /* Library Specific Templates */
    
    MetroTileHomepageALT: {
        width: 1020,
        numModules: 8,
        getTemplate: function(moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 156,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        moduleArray[7]
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 490,
                    modules: [
                        {
                            modules: [
                                moduleArray[0],
                                moduleArray[2]
                            ]
                        },
                        {
                            modules: [
                                moduleArray[1],
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[4],
                                {
                                    modules: [
                                        {
                                            id: "dummy",
                                            type: "Module"
                                        },
                                        moduleArray[5]
                                    ]
                                }
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[6]
                            ]
                        }
                    ]
                }
            ];
        }
    },
    
    BoeingClassic: {
        numModules: 0,
        getTemplate: function(moduleArray) {
            return [
                {
                    height: 180,
                    colCount: 3,
                    modules: [
                        {
                            type: "Module",
                            id: "dummy",
                            colSpan: 2
                        },
                        {
                            title: "Help and Support",
                            type: "HTML",
                            id: "news",
                            colSpan: 1,
                            options: {
                                html:
                                    "<p>Check out the links below to take advantage of the new Presentation Builder:</p>" +
                                        "<p>" +
                                        "<a href='javascript:void(0)' onclick='Librarian.Utils.selectTreeNodeByPath(treeView, \"MasterLibrary/Training/Training Guides\", null, true);' >Access User Guides <img src='themes/default/images/Transparent.png'></a>" +
                                        "</p>" +
                                        "<p name='buttonHeader'>Make the most of Presentation Builder:</p>" +
                                        "<div class='pure-button' onclick='Librarian.Utils.selectTreeNodeByPath(treeView, \"MasterLibrary/Training/Tutorials\", null, true);' >Watch Video Tutorials <img src='themes/default/images/WHT_ButtonArrow.png'></div>"
                            }
                        }
                    ]
                },
                {
                    height: 235,
                    modules: [
                        {
                            title: "Presentation Wizards",
                            type: "CategoryContent",
                            id: "wizards",
                            options: {
                                catPath: "Wizards",
                                action: "preview"
                            }
                        },
                        {
                            title: "Most Recent Content",
                            type: "Recent",
                            id: "mostrecent",
                            options: {
                                count: 5
                            }
                        },
                        {
                            title: "Quick Links",
                            id: "quicklinks",
                            type: "Links",
                            options: {
                                links: [
                                    {
                                        name: "Boeing Media Room",
                                        href: "http://boeing.mediaroom.com/"
                                    },
                                    {
                                        name: "TotalAccess Express",
                                        href: "https://securelogon.boeing.com/login/secure_logon.html"
                                    },
                                    {
                                        name: "Accent Training",
                                        href: "javascript:void(0)",
                                        onClick: function() {
                                            Librarian.Utils.selectTreeNodeByPath(treeView, "MasterLibrary/Training",
                                                null, true);
                                        }
                                    },
                                    {
                                        name: "Ask Marketing",
                                        href: "mailto:mmoore@accent-technologies.com"
                                    },
                                    {
                                        name: "Technical Support",
                                        href: "mailto:techsupport@accent-technologies.com"
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    height: 250,
                    modules: [
                        {
                            title: Librarian.Lang.getString("modules_featured_title"),
                            type: "FeaturedContent",
                            id: "featuredcontent",
                            options: {
                                mode: "popular"
                            }
                        }
                    ]
                },
                {
                    height: "auto",
                    modules: [
                        {
                            type: "HTML",
                            id: "footer",
                            options: {
                                html:
                                    "For questions about library functions or technical issues,<br/>call 800-771-6011 or email <a href='mailto:techsupport@accent-technologies.com'>techsupport@accent-technologies.com</a>"
                            }
                        }
                    ]
                }
            ];
        },
    },

    webmdcs: {
        numModules: 3,
        getTemplate: function(moduleArray, greetingString) {
            return [
                {
                    height: 100,
                    modules: [
                        {
                            type: "HTML",
                            id: "banner",
                            options: {
                                addClass: "banner",
                                html: "<img src='" +
                                    Librarian.path.getLayoutsPath() +
                                    "core/pagebuilder/images/WebMDCS_Logo.png" +
                                    "' style='height: 47px; width: 202px;' /><span>CONSUMER SALES MARKETING HUB</span>"
                            }
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 6,
                    height: 400,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    type: "HTML",
                                    rowSpan: 3,
                                    id: "info",
                                    options: {
                                        fileName: "stealthis.html"
                                    }
                                }
                            ]
                        },
                        {
                            colSpan: 4,
                            rowSpan: 3,
                            width: 500,
                            modules: [
                                {
                                    colSpan: 4,
                                    modules: [
                                        moduleArray[0]
                                    ]
                                },
                                {
                                    colSpan: 2,
                                    modules: [
                                        moduleArray[1],
                                        moduleArray[2]
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ];
        }
    },

    cdkHomepage1: {
        width: 900,
        numModules: 20,
        getTemplate: function (moduleArray, greetingString) {
            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 5,
                    colCount: 5,
                    height: 830,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0],
                                moduleArray[1]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[2],
                                        moduleArray[3]
                                    ]
                                },
                                moduleArray[4],
                                {
                                    modules: [
                                        moduleArray[5],
                                        moduleArray[6]
                                    ]
                                }
                            ]
                        },
                        {
                            modules: [
                                moduleArray[7],
                                moduleArray[8],
                                moduleArray[9],
                                moduleArray[10]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 1,
                    colCount: 5,
                    height: 156,
                    modules: [
                        moduleArray[11],
                        moduleArray[12],
                        moduleArray[13],
                        moduleArray[14],
                        moduleArray[15]
                    ]
                }
            ];
        }
    },

    cdkHomepage2: {
        width: 900,
        numModules: 18,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 5,
                    height: 490,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0],
                                moduleArray[1],
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[2],
                                {
                                    modules: [
                                        moduleArray[3],
                                        moduleArray[4],
                                    ]
                                }
                            ]
                        },
                        {
                            modules: [
                                moduleArray[5],
                                moduleArray[6],
                                moduleArray[7]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[8],
                                moduleArray[9]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[10],
                                moduleArray[11]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[12],
                                moduleArray[13]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[14],
                                moduleArray[15]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[16],
                                moduleArray[17]
                            ]
                        },
                    ]
                }
            ];
        }
    },

    ubsHomepage: {
        width: 1020,
        numModules: 6,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    height: 76,
                    colCount: 6,
                    modules: [
                        {
                            colSpan: 2,
                            type: "HTML",
                            id: "banner",
                            options: {
                                html: greetingString,
                                addClass: "banner"
                            }
                        },
                        {
                            colSpan: 4,
                            type: "Search",
                            id: "search",
                            options: {
                                searchPlaceholder: "Search All Content",
                                searchButtonText: "Content Search"
                            }
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 6,
                    height: 330,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[0]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[1]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[2],
                                moduleArray[3]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[4],
                                moduleArray[5]
                            ]
                        }
                    ]
                },
                {
                    height: 30,
                    modules: [
                        {
                            type: "HTML",
                            id: "questions",
                            options: {
                                "html":
                                    "For questions about library functions or technical issues, call 855-515-4083 or email marketingcentral@ubs.com"
                            }
                        }
                    ]
                }
            ];
        }
    },

    cdkHomepage3: {
        width: 900,
        numModules: 18,
        getTemplate: function (moduleArray, greetingString) {
            if (!greetingString)
                greetingString = Librarian.PageBuilder.getGreetingString();

            return [
                {
                    rowCount: 1,
                    height: 156,
                    modules: [
                        {
                            modules: [
                                {
                                    type: "HTML",
                                    id: "banner",
                                    options: {
                                        html: greetingString,
                                        addClass: "banner"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    rowCount: 3,
                    colCount: 5,
                    height: 490,
                    modules: [
                        {
                            colSpan: 2,
                            modules: [
                                {
                                    modules: [
                                        moduleArray[0],
                                        moduleArray[1]
                                    ]
                                },
                                moduleArray[2]
                            ]
                        },
                        {
                            colSpan: 2,
                            modules: [
                                moduleArray[3],
                                {
                                    modules: [
                                        moduleArray[4],
                                        moduleArray[5]
                                    ]
                                },
                            ]
                        },
                        {
                            modules: [
                                moduleArray[6],
                                moduleArray[7],
                                moduleArray[8]
                            ]
                        }
                    ]
                },
                {
                    rowCount: 2,
                    colCount: 5,
                    height: 330,
                    modules: [
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[9],
                                moduleArray[10]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[11],
                                moduleArray[12]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[13],
                                moduleArray[14]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[15],
                                moduleArray[16]
                            ]
                        },
                        {
                            colSpan: 1,
                            modules: [
                                moduleArray[17],
                                moduleArray[18]
                            ]
                        },
                    ]
                }
            ];
        }
    }
};
